export const botanyData = {
  departmentName: "Department of Botany",
  bannerImage: "/infrastructure/botony/lab-1.JPG",
  
  about: {
    title: "About the Department",
    content: `The Department of Botany at Rayalaseema University is dedicated to advancing knowledge in plant sciences. 
    Our comprehensive programs cover plant diversity, taxonomy, ecology, physiology, biotechnology, and conservation. 
    We provide extensive education and research opportunities in various fields of botany, preparing students for 
    careers in research, conservation, agriculture, biotechnology, and environmental management. The department emphasizes 
    both classical and modern approaches to understanding plant life and its applications.`,
    highlights: [
      "Well-equipped herbarium and plant museum with extensive collections",
      "Advanced biotechnology and tissue culture laboratory",
      "Botanical garden with diverse plant collections",
      "Active research in medicinal plants, plant biotechnology, and conservation",
      "Field studies and ecological surveys"
    ]
  },

  brochure: {
    title: "Department Brochure",
    pdfLink: "/botany/department-brochure.pdf",
    description: "Download our comprehensive department brochure for detailed information."
  },

  hod: {
     
      id: "bot002",
      name: "Dr. G. Sri Ranganayakulu",
      designation: "Co-ordinator & Assistant Professor (MTS)",
      email: "gsranganaayakulu@gmail.com",
      mobile: "9989239242",
      photo: "/botany/ranga.JPG",
      qualification: "M.Sc., Ph.D.",
      
      profileLink: "/botany/ranga.pdf",
       specialization: "Plant Physiology and Molecular Biology", 
    message: `Welcome to the Department of Botany at Rayalaseema University. We are committed to excellence in 
    botanical education and research. Our department provides a stimulating environment for students to explore the 
    fascinating world of plants and their applications. We encourage innovation in plant sciences and emphasize the 
    importance of plant conservation for sustainable development.`,
  
   
    // id:"bot001",
    // name: "Dr. Bharath Kumar Ravuru",
    // designation: "Professor & Head",
    // photo: "/botany/bharath.JPG",
    // email: "drbharathravuru@gmail.com",
    // mobile: "8500722075",
    // qualification: "M.Sc., Ph.D.",
    
  
  },

  bos: {
  title: "Botany",
  members: [
    {
      name: "Prof. R. Bharath Kumar",
      designation: "Chairperson",
      affiliation: "Dept. of Botany, Rayalaseema University, Kurnool"
    },
    {
      name: "Prof. Ch. Ramesh",
      designation: "Member",
      affiliation: "Dept. of Botany, Karnatak University, Dharwad"
    },
    {
      name: "Dr. P. Balakoti Reddy",
      designation: "Member",
      affiliation: "Director (R&D), LOKA Biosciences Pvt. Ltd., Hyderabad"
    },
    {
      name: "Prof. T. Vijaya",
      designation: "Member",
      affiliation: "Dept. of Botany, S.V. University, Tirupati"
    },
    {
      name: "Prof. P. Chandra Obul Reddy",
      designation: "Member",
      affiliation: "Professor, Dept. of Botany, Yogi Vemana University, Kadapa"
    },
    {
      name: "Prof. K. Mallikarjuna",
      designation: "Member",
      affiliation: "Dept. of Botany & Microbiology, Acharya Nagarjuna University, Guntur"
    }
  ]
}
,

  faculty: [
    {
      id: "bot001",
      name: "Dr. Bharath Kumar Ravuru",
      designation: "Professor & Head",
      email: "drbharathravuru@gmail.com",
      mobile: "8500722075",
      photo: "/botany/bharath.JPG",
      qualification: "M.Sc., Ph.D.",
      specialization: "Plant Biotechnology, Ethnobotany &  Forest Ecology",
      profileLink: "/botany/bharath.pdf"
    },
     {
      id: "bot002",
      name: "Dr. G. Sri Ranganayakulu",
      designation: "Co-Ordinator,Assistant Professor (MTS)",
      email: "gsranganaayakulu@gmail.com",
      mobile: "9989239242",
      photo: "/botany/ranga.JPG",
      qualification: "M.Sc., Ph.D.",
      specialization: "Plant Physiology and Molecular Biology ",
      profileLink: "/botany/ranga.pdf"
    },
    
   
    {
      id: "bot003",
      name: "Dr. K. Venkata Ratnam",
      designation: "Assistant Professor (C)",
      email: "drvenkatapkd@gmail.com",
      mobile: "8008497926",
      photo: "/botany/venkataramanabotony.JPG",
      qualification: "M.Sc.,M.Phil, Ph.D.",
      specialization: "Ethnobotany, Plant Taxonomy, Microbiology, Animal Tissue Culture",
      profileLink: "/botany/VENKATA.pdf"
    },
    {
      id: "bot004",
      name: "Dr. Kavitha Bommana",
      designation: "Assistant Professor (C)",
      email: "kavithab15@Gmail.com",
      mobile: "9290755720",
      photo: "/botany/kavitha.JPG",
      qualification: "M.Sc., M.Phil, Ph.D.",
      specialization: "Phytomedicine & Pharmacognostic Studies of Herbal drugs ",
      profileLink: "/botany/KAVITHA.pdf"
    }
  ],

  courses: {
    undergraduate: [
      {
        name: "B.Sc. Horticulure",
        duration: "3 Years",
        eligibility: "10+2 with Biology",
        intake: "60 seats"
      }
    ],
    postgraduate: [
      {
        name: "M.Sc. Botany",
        duration: "2 Years",
        eligibility: "B.Sc. with Botany",
        intake: "30 seats"
      }
    ],
    research: [
      {
        name: "Ph.D. in Botany",
        duration: "Minimum 3 Years",
        eligibility: "M.Sc. Botany",
        areas: "Plant Biotechnology, Ethnobotany &  Forest Ecology "
      }
    ]
  },

  Infrastructure: [
  "/infrastructure/botony/class-1.JPG",
  "/infrastructure/botony/class-2.JPG",
  "/infrastructure/botony/class-3.JPG",
  "/infrastructure/botony/lab-1.JPG",
  "/infrastructure/botony/lab-2.JPG",
  "/infrastructure/botony/lab-3.JPG",
  "/infrastructure/botony/lab-4.jpg",
  "/infrastructure/botony/lab-5.JPG",
  "/infrastructure/botony/lab-6.JPG",
  "/infrastructure/botony/lab-7.JPG",
  "/infrastructure/botony/lab-8.JPG",
  "/infrastructure/botony/lab-9.jpg",
  "/infrastructure/botony/lab-10.jpg"
]
};
